import { render, staticRenderFns } from "./courseSelectorCourseGroup.vue?vue&type=template&id=28c42d78&scoped=true&"
import script from "./courseSelectorCourseGroup.vue?vue&type=script&lang=js&"
export * from "./courseSelectorCourseGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c42d78",
  null
  
)

export default component.exports